import { render, staticRenderFns } from "./OffersListPage.vue?vue&type=template&id=3a1faebc&"
import script from "./OffersListPage.vue?vue&type=script&lang=js&"
export * from "./OffersListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports